import React from 'react';
import { forwardRef } from 'react';
import SelectReact from 'react-select';

function CustomSelectReact(props, ref) {
  return <SelectReact classNamePrefix="react_select" {...props} ref={ref} />;
}

export default forwardRef(CustomSelectReact);
